// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBAzAUg6Fm2sDjJq_sYOMwSQZXQLGA-9iE",
  authDomain: "taiwanteachermike-7681b.firebaseapp.com",
  projectId: "taiwanteachermike-7681b",
  storageBucket: "taiwanteachermike-7681b.appspot.com",
  messagingSenderId: "101463041824",
  appId: "1:101463041824:web:e7e6dbd7a0cfebe3365945"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
